module.exports = __webpack_public_path__ + "img/c3ecafb679cbac3fc72614f2a4e413a6.2fd9f1eb.png";